<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: justify;">Rev Musandiwa Patrick Nemabubuni is a reformed Christian husband to Meriam and a father to Emmanuel, Eternity and Ezra. Patrick completed his Master of Arts in Biblical Counselling at The Master’s University in California, USA, on 4 June 2018. On 6 September 2016, he became the first Black African to be accredited as a biblical counsellor by the highest authority (board) of biblical counsellors in the world called the Association of Certified Biblical Counsellors USA (www.biblicalcounseling.com). Patrick is an author and a teaching pastor in a reformed Christian church called Glorious Fellowship Church in Pretoria, South Africa.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?79b84f1c